/**
 * This is a map of all features from <a href="https://dev.kwh.fino.digital/flags">https://dev.kwh.fino.digital/flags</a>
 * If you want to add a new feature flag you first have to add the feature at this page.
 * Then add the new feature to this map.
 *
 */
export const FeatureFlagNames = {
  FF_AUTO_APPLY_STANDING_ORDERS: 'autoApplyStandingOrders',

  FF_GET_PERSONENDATEN_FROM_ATRUVIA: 'getPersonendatenFromAtruvia',

  FF_DISABLE_CHECK_ASCII_LETTER: 'disableCheckAsciiLetter',

  FF_ADD_NEW_PAYMENT_PARTNER: 'addNewPaymentPartner',

  FF_BANK_EMLOYEE_EMAIL_ADRESS_ON_WARRANT_STATE_REQUIRED:
    'bankEmployeeEmailAddressOnWarrantStateRequired',

  FF_BALANCE_LIST_UPLOAD_PRIVACY_COMPLIANT: 'balanceListUploadPrivacyCompliant',

  FF_CAN_EDIT_BRANCH_ID: 'canEditBranchId',

  FF_CAN_NOTIFY_BRANCH: 'canNotifyBranch',

  FF_CONFIRM_PAYMENT_PARTNER_SUBMIT: 'confirmPaymentPartnerSubmit',

  FF_DISABLE_DEADLINE_IN_TICKET_LIST: 'disableDeadlineInTicketList',

  FF_CAN_DOWNLOAD_BAFIN_REPORT: 'canDownloadBafinReport',

  /**
   * Disable (hide) the chart on the ticket list state.
   */
  FF_DISABLE_TICKET_LIST_CHART: 'disableTicketListChart',

  FF_DISABLE_TICKET_LIST_CSV_DOWNLOAD: 'disableTicketListCsvDownload',

  FF_DISABLE_TICKET_LIST_SEARCH: 'disableTicketListSearch',

  FF_DISABLE_TRASH_ICON_TICKET_LIST: 'disableTrashIconTicketList',

  FF_DISABLE_REMOVE_FINANCE_ITEM: 'disableRemoveFinanceItem',

  FF_OLD_BANK_FINANCES_OPT_IN: 'oldBankFinancesOptIn',

  FF_SIGNATURE_PAYMENT_PARTNER_STATE: 'signaturePaymentPartnerState',

  FF_SHOW_ACCOUNTSWITCH_DATE_ON_CREATE_REQUEST_COLLISION_MODAL:
    'showAccountswitchDateOnCreateRequestCollisionModal',

  FF_ENABLE_WALK_ME: 'enableWalkMe',

  FF_USER_CAN_DELETE_BALANCELIST_ON_FINANCE_STATE:
    'userCanDeleteBalanceListOnFinanceState',

  FF_WITH_GUIDANCE: 'withGuidance',

  FF_WITHOUT_GUIDANCE: 'withoutGuidance',

  FF_ACCOUNT_CLOSE_DATE: 'accountCloseDeadline',

  FF_CUSTOMER_ENTRY: 'customerEntry',

  FF_DISABLE_PROGRESS_HEADER_FOR_INCOMING_REQUEST:
    'disableProgressHeaderForIncomingRequest',

  FF_SPLIT_TICKET_PROGRESSION_MONTHLY: 'splitTicketProgressionMonthly',

  FF_DISABLE_VERIFYING_FINANCES: 'disableVerifyingFinances',

  FF_DISABLE_DOCUMENT_STATUS_FOR_INBOX: 'disableDocumentStatusForInbox',

  FF_REDUCE_DOCUMENT_TYPES_FOR_INBOX: 'reducedDocumentTypesForInbox',

  FF_SPLIT_BY_SWITCH_PRODUCTS: 'splitBySwitchProducts',

  FF_EASTER_EGG_IN_HEADERBAR: 'easterEggInHeaderbar',

  FF_MANUAL_ARCHIVE_SPECIFIC_TICKET: 'manualArchiveSpecificTicket',

  /**
   * Enable control button to toggle all finance list entries.
   */
  FF_ENABLE_FINANCE_LIST_TOGGLE_ALL: 'enableFinanceListToggleAll',

  FF_HIDE_DEADLINE_FOR_WAITING_FOR_TRANSFERRING:
    'hideDeadlineForWaitForTransferring',

  FF_SHOW_TICKET_OWNER: 'showTicketOwner',

  FF_NACHLASS: 'nachlass',

  FF_CONTRACT_CANCELLATION: 'contractCancellation',

  FF_SET_PACKAGE_PASSWORD_IN_SUBMIT_WARRANT_STATE:
    'setPackagePasswordInSubmitWarrantState',

  FF_DUPLICATE_TICKET_WARNING: 'duplicateTicketWarning',

  FF_INBOX_FOR_NEW_AND_DONE_DOCUMENTS: 'inboxForNewAndDoneDocuments',

  FF_INBOX_FOR_REJECTED_DOCUMENTS_WIHTOUT_IBAN:
    'inboxForRejectedDocumentsWithoutIBAN',

  FF_EDIT_CUSTOMER_NAME_IN_OUTGOING_TICKETS:
    'editCustomerNameInOutgoingTickets',

  FF_ENABLE_SIGNOTEC_SIGNATURE: 'enableSignoTecSignature',

  FF_STANDING_ORDERS_DOWNLOAD: 'standingOrdersDownload',

  FF_GROUP_MULTIPLE_CONTRACTS: 'groupMultipleContracts',

  FF_SKIP_WARRANT_SHIPMENT: 'skipWarrantShipment',

  FF_TOGGLE_REMINDERS: 'toggleReminders',

  FF_PROVIDE_PAYMENT_PARTNERS_OVERVIEW_DOC_FOR_MANUAL_CHECK:
    'providePaymentPartnersOverviewDocForManualCheck',

  FF_PRECHECK_INFORM_CUSTOMER_CHECKBOX_ON_WARRANT_FORM:
    'precheckInformCustomerCheckboxOnWarrantForm',

  FF_ACCOUNT_CLOSE_SECTION_AT_BEGINNING_OF_WARRANT_FORM:
    'accountCloseSectionAtBeginningOfWarrantForm',

  FF_VALIDATE_IBANS_BEFORE_UPLOADING_BALANCE_LIST:
    'validateIBANsBeforeUploadingBalanceList',

  FF_SHOW_CHECKBOX_FOR_ACCEPT_SIGNATURE_USAGE_FOR_SEPA:
    'showCheckboxForAcceptSignatureUsageForSEPA',

  FF_HIDE_PACKAGE_PASSWORD_ON_PAYMENT_PARTNER_STATE:
    'hidePackagePasswordOnPaymentPartnerState',

  FF_SHOW_BRANCH_ID_IN_TICKET_OVERVIEW: 'showBranchIdInTicketOverview',

  FF_SHOW_DOWNLOAD_USER_CHANGE_HISTORY: 'showDownloadUserChangeHistory',

  FF_ALREADY_TREATED_CHECKBOX_ON_PARTNER_CARD:
    'alreadyTreatedCheckboxOnPartnerCard',
};
